/** Money — the reservation system's pricing as it sent it (read-only: currency, prices,
 *  tax, settlement, receipt, its own created / updated times), then the order's
 *  provenance (integration, account, created / updated). Times in UTC, labelled. */
import type { OrderRecordStage } from '@/api/orderRecord';
import type { ViewSection } from '@/features/records/views/types';

import type { OrderDisplayContext } from './displays';
import { OrderStagePanel } from './OrderStagePanel';

export function MoneyPanel({
  section,
  display,
}: {
  section: ViewSection<OrderRecordStage>;
  display: OrderDisplayContext;
}) {
  return <OrderStagePanel section={section} display={display} />;
}
